/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkDeleteFacilityServiceAreasResponse
 */
export interface BulkDeleteFacilityServiceAreasResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkDeleteFacilityServiceAreasResponse
     */
    deleted: number;
}

/**
 * Check if a given object implements the BulkDeleteFacilityServiceAreasResponse interface.
 */
export function instanceOfBulkDeleteFacilityServiceAreasResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "deleted" in value;

    return isInstance;
}

export function BulkDeleteFacilityServiceAreasResponseFromJSON(json: any): BulkDeleteFacilityServiceAreasResponse {
    return BulkDeleteFacilityServiceAreasResponseFromJSONTyped(json, false);
}

export function BulkDeleteFacilityServiceAreasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteFacilityServiceAreasResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deleted': json['deleted'],
    };
}

export function BulkDeleteFacilityServiceAreasResponseToJSON(value?: BulkDeleteFacilityServiceAreasResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deleted': value.deleted,
    };
}

